<template>
    <header class="header" :class="[{'show-navi' : ($store.state.show_navi || show_navi)}]" @mouseover="showNavi(true)" @mouseleave="showNavi(false)">
        <div class="inner">
            <h1 class="logo">
                <router-link to="/">
                    <SvgIcon name="logo"/>
                    <span>{{$store.state.site_name}}</span>
                </router-link>
            </h1>
            <span class="mobile-trigger" @click="openMobileMenu">
                <svg viewBox="0 0 21 14">
                    <line x1="21" y1="0.9" x2="-7.18387e-08" y2="0.899998" />
                    <line x1="21" y1="6.9" x2="-7.18387e-08" y2="6.9" />
                    <line x1="21" y1="12.9" x2="-7.18387e-08" y2="12.9" />
                </svg>
            </span>
            <nav class="navi" :class="{'open-search': is_open_search}">
                <h2><router-link to="/">{{$store.state.site_name}} <span>{{$store.state.site_description}}</span></router-link></h2>
                <ul v-if="navi && navi.length !== 0">
                    <li v-for="item in navi" :key="item.ID" class="menu-item">
                        <Link :link="item" v-html="item.title"></Link>
                    </li>
                    <li class="search" @click="openSearch">
                        <span>
                            <SvgIcon name="search"/>
                        </span>
                    </li>
                </ul>
                <div class="search-form">
                    <div class="input">
                        <span class="close" @click="is_open_search = false; "><SvgIcon name="close"/></span>
                        <input ref="input" placeholder="type and return to search" v-model="keyword" @keyup.enter="search" />
                    </div>
                </div>
            </nav>
        </div>
    </header>

</template>

<script>
import Link from '@/components/ui/Link.vue';
import SvgIcon from '@/components/ui/SvgIcon.vue';

export default {
    name: 'Header',

    data () {
        return {
            navi: [],
            show_navi: true,
            last_scroll_position: 0,
            offset: 100,
            is_open_search: false,
            is_sticky: false,
            keyword: '',
        }
    },

    watch: {
        '$route.params': {
            handler() {
                this.is_open_search = this.$route.name === 'search';
                this.keyword = this.$route.query.key_word;
            },
            immediate: true,
        }
    },

    components: {
        Link,
        SvgIcon,
    },

    methods: {
        showNavi(type) {
            // console.log(type);
            this.$store.state.show_navi = type;
        },
        search() {
            if (this.keyword && this.keyword !== '') {
                this.$router.push({ 
                    path: '/search/',
                    query: {
                        key_word: this.keyword
                    } 
                });
            }
        },
        openSearch() {
            if (this.is_open_search) {
                this.search();
            } else {
                this.is_open_search = true;
            }
        },
        onScroll () {
            const current_pos = window.pageYOffset || document.documentElement.scrollTop;

            // if (current_pos > this.offset) {
            //     this.is_sticky = true;
            // } else {
            //     this.is_sticky = false;
            // }

            if (current_pos < this.offset) {
                this.show_navi = true;
            } else {
                this.show_navi = current_pos < this.last_scroll_position;
            }
            
            this.last_scroll_position = current_pos;
        },

        openMobileMenu() {
            document.body.classList.toggle('show-mobile-menu');
        },
    },
    mounted () {
        window.addEventListener('scroll', this.onScroll);

        this.$ajax.get('/menus/2').then(res => {
            this.navi = res.data.items;
        });

        this.$ajax.get('/get-products').then(res => {
            this.$store.state.products = res.data.products;
        });
    },

}
</script>

<style lang="scss">

    .header {
        position: sticky;
        left: 0;
        top: 0;
        z-index: 19;
        width: 100%;
        // background: white;
        text-transform: lowercase;
        font-weight: bold;
        font-size: var(--medium-size);
        // transform: translate(0, calc(100% - 5.3rem));
        // transition: transform .8s;
        overflow: hidden;

        &.show-navi .navi {
            transform: translate(0, 0%);
        }

        .inner {
            position: relative;
        }

        .logo {
            position: absolute;
            left: var(--padding);
            height: 3.2rem;
            width: 3.2rem;
            top: 50%;
            margin-top: -1.5rem;
            z-index: 99;

            svg {
                height: 100%;
                width: 100%;
                display: block;
                fill: var(--font-color);
            }

            a:hover svg {
                fill: var(--yellow);
            }

            span {
                display: none;
            }
        }

        .mobile-trigger {
            transition: transform .2s ease-in-out;
            display: none;
            position: absolute;
            right: var(--padding);
            top: 50%;
            margin-top: -2.2rem;
            height: 4.4rem;
            width: 4.4rem;

            svg {
                fill: none;
                stroke: var(--font-color);
                height: 100%;
                width: 100%;

                line {
                    stroke-width: 1.8;
                    transition: .2s all ease;
                }
            }
        }

        .navi {
            display: flex;
            position: relative;
            align-items: center;
            height: 8rem;
            transform: translate(0, -100%);
            transition: transform .25s;

            &::before {
                position: absolute;
                width: 200vw;
                left: -50vw;
                height: 100%;
                top: 0;
                background: white;
                content: '';
            }

            & > h2 {
                flex: 1;
                position: relative;
                z-index: 3;

                span {
                    color: var(--gray);
                    padding-left: .8rem;
                }
            }

            & > ul {
                display: flex;
                flex-wrap: wrap;
                position: relative;
                z-index: 3;

                li {
                    padding-left: 3rem;
                }

                .router-link-active,
                .router-link-exact-active {
                    color: var(--yellow);
                }
            }



            .search {
                display: flex;
                align-items: center;

                span {
                    display: block;
                    height: 2.2rem;
                    width: 2.2rem;
                    cursor: pointer;
                }

                svg {
                    fill: none;
                    stroke: var(--font-color);
                    stroke-width: 2.6;
                    display: block;
                    height: 100%;
                    width: 100%;
                }

                &:hover svg {
                    stroke: var(--yellow);
                }
            }
        }

        .menu-item {
            transition: opacity .3s ease-in-out;
            opacity: 1;
        }

        .search-form {
            position: absolute;
            right: 3rem;
            z-index: 9;
            transition: width .3s ease-in-out;
            width: 0;
            overflow: hidden;


            .input {
                width: 52rem;
                position: relative;
                
                span {
                    cursor: pointer;
                    height: 1.6rem;
                    width: 1.6rem;
                    position: absolute;
                    right: .3rem;
                    top: 1rem;

                    svg {
                        display: block;
                        height: 100%;
                        width: 100%;
                        stroke: var(--gray);
                        stroke-width: 2;
                    }

                    &:hover svg {
                        stroke: var(--yellow);
                    }
                }
            }
            
            input {
                border: none;
                border-bottom: 1px solid var(--gray);
                width: 100%;
                text-transform: lowercase;
                font-weight: bold;
                font-size: var(--medium-size);
                padding: .3rem 0;

                &:focus {
                    outline: none;
                    border-bottom: 1px solid var(--yellow);
                }
            }
        }

        .open-search {
            .menu-item {
                opacity: 0;
                pointer-events: none;
            }

            .search-form {
                width: 52rem;
            }
        }


    }

    body.page-product .header .navi > ul li:nth-child(1) a,
    body.page-product-category .header .navi > ul li:nth-child(1) a,
    body.page-commission .header .navi > ul li:nth-child(2) a,
    body.page-journal-page .header .navi > ul li:nth-child(4) a,
    body.page-journal-tag .header .navi > ul li:nth-child(4) a {
        color: var(--yellow);
    }

    @media only screen and (max-width: 780px) {

        .header {
            padding: var(--padding) 0;
            background: white;
            overflow: auto;
            height: 4rem;
            z-index: 1000;

            .inner {
                position: static;
            }

            .logo {
                position: absolute;
                width: auto;
                height: auto;
                top: 50%;
                margin-top: -2.2rem;
                left: var(--padding);
                z-index: 1000;
                height: 4.4rem;
                line-height: 1;

                a {
                    display: flex;
                    align-items: center;
                }

                svg {
                    width: 4.4rem;
                    height: 4.4rem;
                }

                span {
                    display: block;
                    padding-left: var(--padding);
                    font-size: var(--title-size);
                }
            }

            .navi {
                display: block;
                height: 100%;
                transform: translate(100%, 0%) !important;
                position: fixed;
                z-index: 999;
                background: #fff;
                left: 0;
                top: 0;
                width: 100%;
                box-sizing: border-box;
                padding: 12rem var(--padding) var(--padding) 9.3rem;

                &::before {
                    display: none;
                }

                & > h2 {
                    display: none;
                }

                & > ul {
                    display: block;
                    z-index: 15;

                    li {
                        padding: 0 0 1rem;
                        font-size: var(--title-size);
                        opacity: 1 !important;
                    }
                }
            }

            .mobile-trigger {
                display: block;
                z-index: 1000;
            }

            .navi .search {
                span {
                    position: absolute;
                    height: 4.2rem;
                    width: 4.2rem;
                    right: 0;
                    z-index: 911;
                    bottom: -4.6rem;
                }
            }

            .search-form {
                position: relative;
                right: auto;
                width: auto;


                .input {
                    width: auto;
                    
                    span {
                        display: none;
                    }
                }
                
                input {
                    border: none;
                    border-bottom: 1px solid var(--gray);
                    width: 100%;
                    
                    // font-size: var(--title-size);
                    padding: 1rem 0;

        
                }
            }

            .open-search {
                .menu-item {
                    opacity: 1;
                    pointer-events: unset;
                }

                .search-form {
                    width: auto;
                }
            }
        }

        .show-mobile-menu  .header {
            
            .mobile-trigger {
                
                svg {
                    line:nth-child(1) {
                        transform: rotate(45deg) translate(10%, -25%);
                    }

                    line:nth-child(2) {
                        opacity: 0;
                    }

                    line:nth-child(3) {
                        transform: rotate(-45deg) translate(-39%, -2%);
                    }
                }
            }

            .navi {
                transform: translate(0%, 0%) !important;
            }
        }
    }

</style>
